import type { RootState } from "@/app/store";
import { Formulario } from "@/contexts/fiscalizacao/formulario/model/Formulario";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FormularioState {
  items: Formulario[];
  synced: boolean;
}

const initialState: FormularioState = {
  items: [],
  synced: false,
};

const formularioSlice = createSlice({
  name: "FORMULARIO",
  initialState,
  reducers: {
    sync: {
      reducer: (state, action: PayloadAction<{ items: Formulario[] }>) => {
        state.items = action.payload.items;
        state.synced = true;
      },
      prepare: (items: Formulario[]) => ({
        payload: { items },
      }),
    },
  },
});

export const formularioAction = formularioSlice.actions;

export default formularioSlice.reducer;

export const getFormularioSynced = (state: RootState) => state.formulario.items;
